import { Navigate } from "react-router-dom";
import { useRole } from "@/hooks/useRole";

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAdmin, loading } = useRole();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground font-mono text-sm">
        Verifying admin access…
      </div>
    );
  }
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
